import { computed, ref, type Ref } from 'vue';
import type { HopDongWizardStep } from '@/types/hop-dong';
import {
  HOP_DONG_WIZARD_STEP_HDVT,
  HOP_DONG_WIZARD_STEP_META,
  HOP_DONG_WIZARD_STEPS,
} from '../constants';

export function useHopDongWizard(options?: {
  onBeforeLeaveMeta?: () => Promise<boolean> | boolean;
}) {
  const step = ref<HopDongWizardStep>(HOP_DONG_WIZARD_STEP_META);

  const currentStepMeta = computed(
    () =>
      HOP_DONG_WIZARD_STEPS.find((item) => item.id === step.value) ??
      HOP_DONG_WIZARD_STEPS[0]
  );

  const isMetaStep = computed(() => step.value === HOP_DONG_WIZARD_STEP_META);
  const isHdvtStep = computed(() => step.value === HOP_DONG_WIZARD_STEP_HDVT);

  const goToMeta = () => {
    step.value = HOP_DONG_WIZARD_STEP_META;
  };

  const goToHdvt = async () => {
    if (options?.onBeforeLeaveMeta) {
      const ok = await options.onBeforeLeaveMeta();

      if (!ok) {
        return false;
      }
    }

    step.value = HOP_DONG_WIZARD_STEP_HDVT;

    return true;
  };

  const goBack = () => {
    if (isHdvtStep.value) {
      goToMeta();
    }
  };

  const resetWizard = () => {
    step.value = HOP_DONG_WIZARD_STEP_META;
  };

  return {
    step: step as Ref<HopDongWizardStep>,
    steps: HOP_DONG_WIZARD_STEPS,
    currentStepMeta,
    isMetaStep,
    isHdvtStep,
    goToMeta,
    goToHdvt,
    goBack,
    resetWizard,
  };
}
